<mat-card>
  <mat-card-title *ngIf="enabledImport === false">Vous n'êtes pas autoriser à importer.</mat-card-title>

  <ng-container *ngIf="enabledImport && avalaible">
    <mat-card-title> Sélectionner une catégorie</mat-card-title>

    <mat-card-content *ngIf="enabledImport && avalaible" class="container">
      <button mat-stroked-button (click)="galleriesImport.click()">
        <span class="title">Galeries : </span>
        <span class="subtitle">Importer un fichier Excel contenant des données de galerie</span>
      </button>

      <button mat-stroked-button (click)="locationsImport.click()">
        <span class="title">Locations : </span>
        <span class="subtitle">Importer un fichier Excel contenant des données de location</span>
      </button>

      <button mat-stroked-button (click)="yearlyRentReportsImport.click()">
        <span class="title">Rapports annuels : </span>
        <span class="subtitle">Importer un fichier Excel contenant des données de gestion annuel</span>
      </button>

      <button mat-stroked-button (click)="monthlyRentReportsImport.click()">
        <span class="title">Rapports mensuels : </span>
        <span class="subtitle">Importer un fichier Excel contenant des données de gestion mensuel</span>
      </button>
    </mat-card-content>
  </ng-container>

  <ng-container *ngIf="avalaible === undefined">
    <mat-card-title> Vérification de la disponibilté du service d'importation </mat-card-title>
    <mat-card-content class="spiner"> <mat-spinner></mat-spinner> </mat-card-content>
  </ng-container>

  <ng-container *ngIf="avalaible === false">
    <mat-card-content> <app-report-progress></app-report-progress> </mat-card-content>
  </ng-container>

  <mat-card-actions align="end">
    <button mat-button (click)="close()"><mat-icon>close</mat-icon></button>
  </mat-card-actions>
</mat-card>

<input
  class="hidden"
  type="file"
  #galleriesImport
  name="Upload Excel"
  id="txtFileUpload"
  (change)="uploadGalleriesDataListener($event.target.files)"
  (click)="resetInput($event.target)"
  accept=".xlsx"
/>

<input
  class="hidden"
  type="file"
  #locationsImport
  name="Upload Excel"
  id="txtFileUpload"
  (change)="uploadLocationsDataListener($event.target.files)"
  (click)="resetInput($event.target)"
  accept=".xlsx"
/>

<input
  class="hidden"
  type="file"
  #yearlyRentReportsImport
  name="Upload Excel"
  id="txtFileUpload"
  (change)="uploadYearlyListener($event.target.files)"
  (click)="resetInput($event.target)"
  accept=".xlsx"
/>

<input
  class="hidden"
  type="file"
  #monthlyRentReportsImport
  name="Upload Excel"
  id="txtFileUpload"
  (change)="uploadMonthlyReportsListener($event.target.files)"
  (click)="resetInput($event.target)"
  accept=".xlsx"
/>
